import React, { type FC } from 'react';

import { Box } from '@adsk/alloy-react-box';
import { ModalConfirmation } from '@adsk/alloy-react-modal';

import { useTranslation } from '../../i18n';

type AttachmentDeleteConfirmationModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  fileName: string;
};

const AttachmentDeleteConfirmationModal: FC<
  AttachmentDeleteConfirmationModalProps
> = ({ open, onClose, onConfirm, fileName }) => {
  const { t } = useTranslation();

  return (
    <ModalConfirmation
      hideOnConfirm
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title={t('DELETE_ATTACHMENT')}
      confirmationButtonLabel={t('DELETE') as string}
      message={
        <Box>{t('DELETE_ATTACHMENT_TEXT', { attachmentName: fileName })}</Box>
      }
    />
  );
};

export default AttachmentDeleteConfirmationModal;
